import styled from '@emotion/styled';
import { BodyContent } from '@lbcamden/lib-react';

/** Vertically centred */
export const BodyContentVC = styled(BodyContent)`
  flex: 0;
  margin: auto;
`;
